// components/layout/BentoBoxGrid.jsx
import React from 'react';
import { Box } from '@mui/material';

const BentoBoxGrid = ({ children, rows = 12, gap = 2, column=12 }) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: `repeat(${column}, 1fr)`,
        gridTemplateRows: `repeat(${rows}, 1fr)`,
        gap: gap,
      }}
    >
      {children}
    </Box>
  );
};

export default BentoBoxGrid;
